import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { SnackBarService } from '../../services/snackbar.service';
import { BDAttachment } from '../../domain/bd/bd-attachment.model';
@Component({
  selector: 'cm-blocklist-attachments-dialog',
  template: `
    <h4 mat-dialog-title>Attachments</h4>
    <div mat-dialog-content>
      <div class="d-flex flex-column">
        <span *ngFor="let link of links">
          <a target="_blank" href="{{link.link}}"
             mat-button
             color="primary"
             class="w-100">
            <span class="text-truncate" title="{{link.filename}}">{{link.filename}}</span>
          </a>
        </span>
      </div>
    </div>
    <div mat-dialog-actions class="mt-3 justify-content-center">
      <button mat-raised-button color="" class="" [mat-dialog-close]="false">Close</button>
    </div>
  `,
})
export class BlocklistAttachmentsDialogComponent {

  links: BDAttachment;

  constructor(public dialogRef: MatDialogRef<BlocklistAttachmentsDialogComponent>,
    private snackBarService: SnackBarService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.links = data.links;
  }

}
